import React from 'react';

import { ISCBTextRow } from 'types/interfaces/sulu/IContentBlocks';

const TextRow = ({ text }: ISCBTextRow) => (
  <p className='mb-4 text-xl font-light'>{text}</p>
);

export default TextRow;
